import React from 'react';
import PropTypes from 'prop-types';
import { ListingType } from '@domain-group/fe-allhomes-library';
import sortOptions, { DEFAULT_SORT } from './sort-options';
import RadioGroup from './radio-group';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesSearchSortingMobile = props => ___EmotionJSX(RadioGroup, {
  options: sortOptions(props.listingType),
  currentValue: props.value,
  onChange: props.onSelect
});
AllhomesSearchSortingMobile.propTypes = {
  listingType: PropTypes.string,
  value: PropTypes.string,
  onSelect: PropTypes.func
};
AllhomesSearchSortingMobile.defaultProps = {
  listingType: ListingType.SALES_RESIDENTIAL.name,
  value: DEFAULT_SORT,
  onSelect: () => {}
};
export default AllhomesSearchSortingMobile;